// ===== Selector =====
(function() {
  const selector = document.getElementById('selector');
  if (!selector) return;

  const totalEl = document.getElementById('totalPrice');
  const saveEl = document.getElementById('totalSave');
  const ctaPriceEl = document.getElementById('ctaPrice');
  const stickyPrice = document.getElementById('stickyPrice');
  const stickyVariant = document.getElementById('stickyVariant');

  const fmt = (n) => new Intl.NumberFormat('uk-UA').format(n) + ' ₴';

  function updateTotal(card) {
    const qty = parseInt(card.dataset.qty, 10) || 1;
    const discount = parseInt(card.dataset.discount, 10) || 0;
    const baseUnit = parseInt(selector.dataset.basePrice || '1490', 10);
    /* [2026-07-07 · Claude · promo-60] якір економії = compare_at (стара ціна), а не поточна */
    const anchorUnit = parseInt(selector.dataset.baseAnchor || '0', 10) || baseUnit;
    const price = Math.round(baseUnit * qty * (100 - discount) / 100);
    const full = anchorUnit * qty;
    const save = full - price;
    const qtyInput = document.getElementById('ehQuantity');
    if (qtyInput) qtyInput.value = qty;
    if (totalEl) totalEl.textContent = fmt(price);
    if (saveEl) {
      if (save > 0) {
        saveEl.textContent = '−' + fmt(save);
        saveEl.style.display = '';
      } else {
        saveEl.style.display = 'none';
      }
    }
    if (ctaPriceEl) ctaPriceEl.textContent = fmt(price);
    const totalWasEl = document.getElementById('totalWas');
    if (totalWasEl) totalWasEl.textContent = save > 0 ? fmt(full) : '';
    const ctaWasEl = document.getElementById('ctaWas');
    if (ctaWasEl) ctaWasEl.textContent = save > 0 ? fmt(full) : '';
    if (stickyPrice) stickyPrice.textContent = fmt(price);
    const stickyWasEl = document.getElementById('stickyWas');
    if (stickyWasEl) stickyWasEl.textContent = save > 0 ? fmt(full) : '';
    if (stickyVariant) {
      const label = card.dataset.qtyLabel || (qty === 1 ? '1 пачка' : qty < 5 ? qty + ' пачки' : qty + ' пачок');
      stickyVariant.textContent = discount ? label + ' · −' + discount + '%' : label;
    }
  }

  selector.addEventListener('click', (e) => {
    const card = e.target.closest('.selector-card');
    if (!card) return;
    [...selector.querySelectorAll('.selector-card')].forEach(c => c.classList.remove('active'));
    card.classList.add('active');
    updateTotal(card);
  });

  // init
  const initActive = selector.querySelector('.selector-card.active');
  if (initActive) updateTotal(initActive);
})();

// ===== FAQ accordion =====
(function() {
  const wrap = document.getElementById('faqWrap');
  if (!wrap) return;
  wrap.addEventListener('click', (e) => {
    const btn = e.target.closest('.faq-q');
    if (!btn) return;
    const item = btn.parentElement;
    item.classList.toggle('open');
  });
})();

// ===== Product accordion (ingredients / facts / how to take) =====
(function() {
  const wrap = document.getElementById('productAccordion');
  if (!wrap) return;
  wrap.addEventListener('click', (e) => {
    const btn = e.target.closest('.pa-q');
    if (!btn) return;
    const item = btn.parentElement;
    item.classList.toggle('open');
  });
})();

// ===== Gallery thumbs =====
(function() {
  const thumbs = document.getElementById('galleryThumbs');
  const main = document.getElementById('galleryMainImg');
  if (!thumbs || !main) return;
  thumbs.addEventListener('click', (e) => {
    const btn = e.target.closest('.gallery-thumb');
    if (!btn) return;
    [...thumbs.children].forEach(t => t.classList.remove('active'));
    btn.classList.add('active');
    // Read from the inner (bundler-inlined) img so swap works in standalone too
    const innerImg = btn.querySelector('img');
    if (innerImg && innerImg.src) main.src = innerImg.src;
    else if (btn.dataset.src) main.src = btn.dataset.src;
  });
})();

// ===== Add to cart =====
(function() {
  const btn = document.getElementById('addToCart');
  const selector = document.getElementById('selector');
  if (!btn) return;

  const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  btn.addEventListener('click', async () => {
    const active = document.querySelector('.selector-card.active');
    const qty = active ? parseInt(active.dataset.qty, 10) || 1 : 1;
    const variantInput = document.getElementById('ehVariantId');
    const variantId = variantInput
      ? parseInt(variantInput.value, 10)
      : parseInt(selector && selector.dataset.variantId, 10);

    if (!variantId) return;

    const orig = btn.innerHTML;
    btn.disabled = true;

    try {
      const addRes = await fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: qty }]
        })
      });

      if (!addRes.ok) throw new Error('Add to cart failed');

      const cartRes = await fetch(cartRoot + 'cart.js');
      if (cartRes.ok) {
        const cart = await cartRes.json();
        const count = document.querySelector('.cart-count');
        if (count) count.textContent = cart.item_count;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }

      btn.innerHTML = '✓ Додано в кошик';
      btn.style.background = 'var(--ink)';
      setTimeout(() => {
        btn.innerHTML = orig;
        btn.style.background = '';
      }, 1400);
    } catch (err) {
      btn.innerHTML = 'Помилка — спробуйте ще';
      setTimeout(() => {
        btn.innerHTML = orig;
      }, 1800);
    } finally {
      btn.disabled = false;
    }
  });
})();

// ===== Sticky buy bar visibility =====
(function() {
  const sticky = document.getElementById('stickyBuy');
  const product = document.querySelector('.product');
  if (!sticky || !product) return;
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(en => {
      if (en.isIntersecting) sticky.classList.remove('visible');
      else if (window.scrollY > product.offsetTop) sticky.classList.add('visible');
    });
  }, { threshold: 0, rootMargin: '0px 0px -200px 0px' });
  obs.observe(product);
})();
